import { Injectable, inject } from '@angular/core';
import { CreateLenderAuditLogRequest, LenderAuditLog, LenderAuditResult } from '@shared/models/lender-audit';
import { LenderHubDataService } from '@shared/services/lenderhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class LenderAuditService {
  private readonly lenderHubDataService = inject(LenderHubDataService);

  public getAuditHistory() {
    return this.lenderHubDataService.get<LenderAuditLog[]>('LenderAudit');
  }

  public addLenderAudit(model: CreateLenderAuditLogRequest) {
    return this.lenderHubDataService.post('LenderAudit', model);
  }

  public updateLenderAudit(logReferenceId: string, newResult: LenderAuditResult) {
    return this.lenderHubDataService.put(`LenderAudit/${logReferenceId}/result`, newResult);
  }
}
